/**
 * Podkategorie — počet produktů na kartě
 *
 * Shoptet počet produktů v podkategorii nikam nevypisuje, takže se dotahuje
 * stejně jako na www.abstore.cz: stránka každé podkategorie se stáhne fetchem
 * a číslo se přečte z její hlavičky výpisu. Aby to nebyl request na každé
 * načtení, výsledky drží localStorage s denní platností.
 *
 * Kvůli šetrnosti k serveru jde vždy jen JEDEN request naráz (fronta, ne
 * paralelní salva) a jen za podkategorie, které v cache nejsou.
 *
 * Vzhled řeší CSS v pages/category.scss (.subcategories__name,
 * .subcategories__count).
 */
(function () {
	var STORE_KEY = 'pestreSubcatCounts';
	var TTL = 24 * 60 * 60 * 1000; // 1 den

	function readCache() {
		try {
			var raw = localStorage.getItem(STORE_KEY);
			if (!raw) return {};
			var parsed = JSON.parse(raw);
			var now = Date.now();
			var fresh = {};
			// Prošlé záznamy rovnou zahodíme, ať úložiště nebobtná.
			Object.keys(parsed).forEach(function (key) {
				if (parsed[key] && now - parsed[key].t < TTL) fresh[key] = parsed[key];
			});
			return fresh;
		} catch (e) {
			// Private mode / zakázané úložiště — počty se prostě nedoplní.
			return {};
		}
	}

	function writeCache(data) {
		try {
			localStorage.setItem(STORE_KEY, JSON.stringify(data));
		} catch (e) {
			// Plné nebo nedostupné úložiště není důvod cokoli rozbíjet.
		}
	}

	// 1 produkt / 2–4 produkty / 5+ produktů
	function plural(count) {
		var word;
		if (count === 1) word = 'produkt';
		else if (count >= 2 && count <= 4) word = 'produkty';
		else word = 'produktů';
		return count.toLocaleString('cs-CZ') + ' ' + word;
	}

	// Počet z hlavičky výpisu; když tam není, spočítáme karty na první
	// stránce (u malých podkategorií to vyjde stejně).
	function parseCount(html) {
		var doc = new DOMParser().parseFromString(html, 'text/html');
		var nodes = doc.querySelectorAll('.category-header-pagination strong');
		if (!nodes.length) nodes = doc.querySelectorAll('.itemsTotal strong, #itemsTotal strong');
		if (nodes.length) {
			var value = parseInt(nodes[nodes.length - 1].textContent.replace(/\D/g, ''), 10);
			if (!isNaN(value)) return value;
		}
		return doc.querySelectorAll('#products .product').length;
	}

	// Název se obalí do <span>, aby šel ořezat zvlášť od počtu produktů
	// (na mobilu se ořezává jen název — viz category.scss).
	function wrapName(link) {
		var text = link.querySelector('.text');
		if (!text || text.querySelector('.subcategories__name')) return;
		var name = document.createElement('span');
		name.className = 'subcategories__name';
		// Jen textové uzly — .image a případné ikony zůstanou, kde jsou.
		Array.prototype.slice.call(text.childNodes).forEach(function (node) {
			if (node.nodeType === 3) name.appendChild(node);
		});
		text.insertBefore(name, text.firstChild);
	}

	function renderCount(link, count) {
		var host = link.querySelector('.text') || link;
		if (host.querySelector('.subcategories__count')) return;
		var span = document.createElement('span');
		span.className = 'subcategories__count';
		span.textContent = plural(count);
		host.appendChild(span);
	}

	function init() {
		var links = document.querySelectorAll('.subcategories li > a');
		if (!links.length) return;

		var cache = readCache();
		var queue = [];

		Array.prototype.forEach.call(links, function (link) {
			wrapName(link);

			var path;
			try {
				path = new URL(link.href, window.location.origin).pathname;
			} catch (e) {
				return;
			}

			if (cache[path]) renderCount(link, cache[path].c);
			else queue.push({ link: link, path: path });
		});

		if (!queue.length) return;

		// Fronta po jednom — ať se neposílá dvacet requestů naráz.
		function next() {
			var job = queue.shift();
			if (!job) {
				writeCache(cache);
				return;
			}
			fetch(job.path, { credentials: 'same-origin' })
				.then(function (response) {
					return response.ok ? response.text() : null;
				})
				.then(function (html) {
					if (html == null) return;
					var count = parseCount(html);
					cache[job.path] = { c: count, t: Date.now() };
					renderCount(job.link, count);
				})
				.catch(function () {
					// Nedostupná podkategorie zůstane bez počtu.
				})
				.then(next);
		}

		next();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('ShoptetDOMPageContentLoaded', init);
})();
